import * as common from "appdevresources/common";
import dataTables from "appdevresources/datatables";
import Routing from "appdevresources/router";

let stickyNotesTable = "";
let noteInterval = null;

$(async function () {
    const stickyNotesTableElement = $("#savedNotesTable");

    if (stickyNotesTableElement.length <= 0) {
        return;
    }

    common.initializeDatePicker();

    $(".addStickyNote").off("click.addNote").on("click.addNote", function () {
        $("#viewStickyNoteListModal").modal("hide");
        $("#addStickyNoteModal").modal("show");
    });

    $("#availableToRoles").on("change", function () {
        isRoleStudentSelected();
    });

    $("#addStickyNoteModal").on("show.bs.modal", function () {
        isRoleStudentSelected();
    });

    $("#btnSaveStickyNote").off("click.sendNewNote").on("click.sendNewNote", function () {
        common.loadSpinner();
        if (common.validateRequired("addStickyNoteForm")) {
            sendNewNote();
        } else {
            common.unloadSpinner();
        }
    });

    stickyNotesTable = await dataTables.create(stickyNotesTableElement, {
        ajax: {
            dataSrc: "",
            url: Routing.generate("api_get_stickynotes")
        },
        rowId: "notePK",
        searching: false,
        paging: false,
        info: false,
        columns: [
            {data: "noteDate"},
            {
                data: "noteRemoveBreaks",
                className: "text-truncate note-no-breaks note-view-open-modal",
                render: function (data) {
                    return `<span data-toggle="tooltip" title="Click to see this note.">${data}</span>`;
                }
            },
            {data: "expireDate"},
            {
                className: "text-md-center",
                data: "canDelete",
                orderable: false,
                render: function (data, type, row) {
                    let returnStr;
                    if (data) {
                        returnStr = "<span class='note-view-open-modal cursor-override-pointer' data-toggle='tooltip' title='Click to see this note.'><i class='fa fa-lg fa-envelope'></i></span> <span class='note-delete cursor-override-pointer' data-toggle='tooltip' title='Delete this note.'><i class='fa fa-lg fa-trash red-text'></i></span>";
                    } else {
                        returnStr = "<span class='note-view-open-modal cursor-override-pointer' data-toggle='tooltip' title='Click to see this note.'><i class='fa fa-lg fa-envelope'></i></span>";
                    }
                    if (row.intlStudentsOnly) {
                        returnStr += " <span data-toggle='tooltip' title='This message is for International Students.'><i class='fa fa-lg  fa-globe'></i></span>";
                    }
                    return returnStr;
                }
            },
            {
                data: "noteBreaks",
                orderable: false,
                visible: false
            }
        ],
        createdRow: function(row, data, index) {
            if (!data.canDelete) {
                $(row).addClass("alert alert-danger font-weight-bold");
            }
        },
        language: {
            emptyTable: "No notes found."
        },
        responsive: false
    });

    //must be destroyed before it is reinitialized
    if ($.fn.dataTable.isDataTable("#savedNotesTable")) {
        clearInterval(noteInterval);
    }

    stickyNotesTableElement.off("click.viewOpen").on("click.viewOpen", ".note-view-open-modal", function () {
        common.loadSpinner();
        $("#noteContentInModal").html(stickyNotesTable.row($(this).closest("tr")).data().noteBreaks);
        common.unloadSpinner();
        $("#viewStickyNoteListModal").modal("hide");
        $("#viewStickyNoteModal").modal("show");
    });

    $("#viewStickyNoteModal").off("hidden.bs.modal").on("hidden.bs.modal", function () {
        $("#viewStickyNoteListModal").modal("show");
    });

    stickyNotesTableElement.off("click.delete").on("click.delete", ".note-delete", function () {
        let selectedNotePK = $(this).parents("tr").attr("id");
        common.confirmationModal("Are you sure you want to delete this sticky note?", function () {
            common.loadSpinner();
            deleteNote(selectedNotePK);
            stickyNotesTable.ajax.reload();
            common.unloadSpinner();
        }, "fa-times-circle-o red-text");
    });

    $(".viewSavedNotes").off("click.showHide").on("click.showHide", function () {
        $("#viewStickyNoteListModal").modal("show");
    });

    stickyNotesTableElement.on("draw.dt", function () {
        let rowCount = stickyNotesTable.rows().count();
        $(".noteCount").html(rowCount);
        if (rowCount === 0) {
            $("[name='noteCountDiv']").addClass("invisible");
            $("#noteCountLi").addClass("d-none");
            $("#addStickyNoteModal").modal("hide");
        } else {
            $("[name='noteCountDiv']").removeClass("invisible");
            $("#noteCountLi").removeClass("d-none");
        }
        common.initializeToolTips();
    });

    if (!noteInterval) {
        //reload every 5 minutes
        noteInterval = setInterval(function () {
            stickyNotesTable.ajax.reload();
        }, 300000);
    }


    function isRoleStudentSelected() {
        let studentChosen = false;
        $("#stickyNoteIntlStudents").hide();
        $("#availableToRoles option:selected").each(function () {
            if ($(this).val() === "ROLE_STUDENT") {
                studentChosen = true;
                $("#stickyNoteIntlStudents").show();
            }
        });
        if (!studentChosen) {
            $("[name='intlOnly'][value='NO']").prop("checked", true);
        }
    }

    //send new sticky note
    function sendNewNote() {
        $.post(Routing.generate("api_new_stickynote"), $("#addStickyNoteForm").serializeArray())
            .done(function () {
                $("#addStickyNoteModal").modal("hide");
                $("#stickyNoteContent").val("");
                $("#expirationDate").val("");
                $("#availableToRoles").val("");
                $("[name='intlOnly']").prop("checked", false);
                stickyNotesTable.ajax.reload();
                common.loadAlert("Sticky note has been saved.", {alertType: "success"});
            })
            .fail(function (qXHR, textStatus, errorThrown) {
                common.loadAlert(`There was an error saving your sticky note: ${errorThrown}. Please contact the OneIT Helpdesk for support.`, {alertType: "danger"});
            })
            .always(function () {
                common.unloadSpinner();
            });
    }

    //delete the chosen note
    function deleteNote(noteId) {
        $.getJSON(Routing.generate("api_delete_stickynote", {id: noteId}))
            .done(function () {
                stickyNotesTable.ajax.reload();
                common.loadAlert("Sticky note has been deleted.", {alertType: "success"});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                common.loadAlert(`There was an error deleting your sticky note: ${errorThrown}. Please contact the OneIT Helpdesk for support.`, {alertType: "danger"});
            })
            .always(function () {
                common.unloadSpinner();
            });
    }
});

console.debug("Loaded library: sticky-notes");
